import EntryActionTypes from '../constants/EntryActionTypes';

const updatePointSystemInCurrentBoard = (isEnabled) => ({
  type: EntryActionTypes.POINT_SYSTEM_IN_CURRENT_BOARD_UPDATE,
  payload: {
    isEnabled,
  },
});

const openPointSystemModalInCurrentBoard = () => ({
  type: EntryActionTypes.POINT_SYSTEM_MODAL_OPEN_IN_CURRENT_BOARD,
  payload: {},
});

export default {
  updatePointSystemInCurrentBoard,
  openPointSystemModalInCurrentBoard,
};
